import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    display: 'flex',
  },
  step: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.colors.white,
    backgroundColor: theme.palette.colors.teal,
    borderRadius: 15,
    width: 30,
    minWidth: 30,
    height: 30,
    marginRight: theme.spacing(2),
  },
  title: {
    color: theme.palette.colors.teal,
    marginBottom: theme.spacing(1),
  },
}));



// WEBPACK FOOTER //
// ./src/components/ReferralRealEstateAgent/components/Guide/components/useStyles.js